import { For } from 'solid-js'
import CheckIcon from '~/assets/images/ic-check.svg'
import NotIncludedIcon from '~/assets/images/ic-not-included.svg'
import { m } from '~/paraglide/messages'

interface ComparisonFeature {
  name: string
  freeVersion: boolean
  plusVersion: boolean
}

const features: ComparisonFeature[] = [
  { name: m.focus_timer(), freeVersion: true, plusVersion: true },
  { name: m.custom_app_allow_list(), freeVersion: false, plusVersion: true },
  { name: m.focus_analysis(), freeVersion: false, plusVersion: true },
  {
    name: m.personalized_focus_experience(),
    freeVersion: false,
    plusVersion: true,
  },
  {
    name: m.free_use_crystal_tree(),
    freeVersion: false,
    plusVersion: true,
  },
  {
    name: m.triple_coin_reward(),
    freeVersion: false,
    plusVersion: true,
  },
  {
    name: m.plant_tree_for_earth(),
    freeVersion: false,
    plusVersion: true,
  },
  {
    name: m.onboarding_paywall_benefit_no_ads(),
    freeVersion: false,
    plusVersion: true,
  },
]

export function ComparisonTable() {
  return (
    <div class="w-full">
      <div class="relative flex w-full flex-col">
        <div class="pointer-events-none absolute bottom-0 right-[-6px] top-0 w-[69px] rounded-[10px] bg-white/20" />

        <div class="flex h-[34px] items-center justify-end">
          <div class="flex items-center gap-4">
            <span class="w-11 text-center text-sm font-semibold text-white">
              {m.free()}
            </span>
            <span class="flex h-[22px] w-[57px] items-center justify-center rounded border-[2px] border-white bg-gradient-to-r from-[#81D200] via-[#0EBC73] to-[#08C1F3] text-center text-xs font-bold text-white">
              PLUS
            </span>
          </div>
        </div>

        <For each={features}>
          {(feature) => (
            <div class="flex h-[46px] items-center justify-between border-white/30 [&:not(:last-child)]:border-b">
              <span class="text-sm text-white">{feature.name}</span>
              <div class="flex items-center gap-11 pr-4">
                {feature.freeVersion ? (
                  <img src={CheckIcon} alt="" />
                ) : (
                  <img src={NotIncludedIcon} alt="" />
                )}
                {feature.plusVersion ? (
                  <img src={CheckIcon} alt="" />
                ) : (
                  <img src={NotIncludedIcon} alt="" />
                )}
              </div>
            </div>
          )}
        </For>
      </div>
    </div>
  )
}
